import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import MilkMoneyAccountingService from '~/api/services/milkMoneyAccounting'
import { FormFields } from '~/components/FormFields'
import Layout from '~/components/Layout'
import { El } from '~/components/Layout/style'
import notify from '~/components/Notify'
import { formatNumbers } from '~/utils/helpers'

const MilkMoney: React.FC = () => {
  const { t } = useTranslation()
  const [isBusy, setIsBusy] = useState(false)

  const { handleSubmit, control, reset, watch, formState: { isDirty } } = useForm({
    mode: 'onSubmit'
  })

  const watchInCheckStatus = watch('inCheckStatusAvailable')

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await MilkMoneyAccountingService.getMilkMoneyToursSettings()
      reset(response.data)
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setIsBusy(false)
  }

  function renderActions() {
    return <El.PageHeaderActionButton disabled={!isDirty}>{t('Update')}</El.PageHeaderActionButton>
  }

  function renderForm() {
    return <div style={{ margin: 20 }}>
      <FormFields.Checkbox
        name='inCheckStatusAvailable'
        defaultValue={0}
        checkboxValue={1}
        control={control}
        label={t('Check status available')}
      />
      {Boolean(watchInCheckStatus) && <FormFields.Checkbox
        name='forwardInCheckFiles'
        defaultValue={0}
        checkboxValue={1}
        control={control}
        label={t('Forward automatically files "in check" status to farmers')}
      />
      }
      <FormFields.Checkbox
        name='deleteFilesAfterImport'
        defaultValue={0}
        checkboxValue={1}
        control={control}
        label={t('Delete files after import')}
      />
      <FormFields.Input
        name='ftpImportInterval'
        control={control}
        label={t('FTP import check interval')}
        placeholder={t('Enter check interval')}
        rules={{
          required: {
            value: true,
            message: t('Please enter interval')
          },
          min: {
            value: 1,
            message: t('Min value is 1')
          },
          max: {
            value: 15,
            message: t('Max value is 15')
          }
        }}
      />
      <FormFields.Input
        name='conversionFactor'
        control={control}
        typeInput='controled'
        allowDecimals
        decimalScale={3}
        label={t('Conversion factor')}
        placeholder={t('Enter conversion factor')}
        rules={{
          required: {
            value: true,
            message: t('Please enter conversion factor')
          },
          validate: (v) => {
            //refactor this, numbers from input are not the same format as api return type is also not a number but string
            const valueFormatted = formatNumbers(v.toString().replace(',', '.'), 3).toString().replace(',', '.')
            const minValueFormatted = formatNumbers(1, 3)
            const maxValueFormatted = formatNumbers(1.1, 3)
            if (parseFloat(valueFormatted) < parseFloat(minValueFormatted)) {
              return t('Min value is {{number}}', { number: minValueFormatted })
            } else if (parseFloat(valueFormatted) > parseFloat(maxValueFormatted)) {
              return t('Max value is {{number}}', { number: maxValueFormatted })
            }
            return true
          }
        }} />
    </div>
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      data.conversionFactor = data?.conversionFactor?.replace(',', '.')
      await MilkMoneyAccountingService.updateMilkMoneyToursSettings(data)
      notify(t('Successfully updated milk money settings'), 'success')
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setIsBusy(false)
  }

  return <Layout
    isBusy={isBusy}
    title={t('Milk money settings')}
    actions={renderActions()}
    segmented
    onSubmit={handleSubmit(onSubmit)}
  >
    {renderForm()}
  </Layout>
}
export default MilkMoney